<style scoped lang="less">
    @import "assets/vars.less";
    .about {
        &_page {
            position: relative;
            padding-top: 70px;
            @media (max-width: 700px) {
                padding-top: 0;
            }
        }
        &_data {
            display: flex;
            align-items: start;
            justify-content: center;
            @media (max-width: 700px) {
                flex-wrap: wrap;
            }
        }
        &_info {
            width: 400px;
            padding: 25px;
            text-align: left;
            > h2 {
                font-weight: 400;
                letter-spacing: 2px;
                color: @dark;
            }
            p {
                color: @dark_gray;
                font-size: 14px;
                padding: 0;
                line-height: 1.5em;
                letter-spacing: .5px;
            }
        }
        &_photo {
            width: 400px;
            img {
                width: 100%;
            }
        }
    }
</style>

<template>
    <div>
        <transition name="fade">
            <div class="about_page">
                <transition name="fade">
                    <div v-if="loaded" class="about_data">
                        <div class="about_photo">
                            <img :src="aboutData.photo" alt="">
                        </div>
                        <div class="about_info">
                            <h2>Евгений Меркулов</h2>
                            <div class="text_format" v-html="aboutData.text"></div>
                        </div>
                    </div>
                </transition>
                <transition name="fade">
                    <div v-if="!loaded" class="loader">
                        <img v-if="!error" src="./assets/waiting.svg" alt="">
                        <p v-if="error">Произошла ошибка</p>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'about',
        data () {
            return {
                loaded: false,
                error: false,
                aboutData: {},
            };
        },
        methods: {
            getInfo () {
                axios
                    .get('https://api.paparazzi48.ru/aboutme')
                    .then(response => {
                        if (response.data) {
                            this.loaded = true;
                            this.aboutData = response.data;
                        }
                    })
                    .catch(() => {
                        this.error = true;
                    });
            },
        },
        mounted () {
            if (!this.loaded) {
                this.getInfo();
            }
        },
    };
</script>